function moveStoreSearchForMobile() {
  const searchBlock = document.querySelector('.store-locator-search');
  const mapWrapper = document.getElementById('store-map-wrapper');
  const storeLayout = document.querySelector('.store-layout');

  if (!searchBlock || !mapWrapper || !storeLayout) return;

  if (window.innerWidth <= 991) {
    mapWrapper.insertAdjacentElement('afterend', searchBlock);
  } else {
    storeLayout.parentNode.insertBefore(searchBlock, storeLayout);
  }
}

document.addEventListener('DOMContentLoaded', moveStoreSearchForMobile);
window.addEventListener('resize', moveStoreSearchForMobile);
  
  
  let storesData = [];
  let allServices = [];
  let selectedServices = [];
  let allStates = [];
  let allCountries = [];
  let googleMap;
  let googleMarkers = [];
  let googleInfoWindow;
  let googleMapsLoader;
  let currentSortOption = 'name-asc';
  let userLocation = null;
  let userLocationPromise = null;
  let searchDebounceTimer = null;
  // const storesJsonUrl = 'https://cdn.shopify.com/s/files/1/0783/9485/1640/files/Flywing-find-store_2cc83e27-21db-448b-8c89-01a7bf68e3a4.json?v=1781740094';
  const storeMapWrapperId = 'store-map-wrapper';
  const storeMapCanvasId = 'store-map-canvas';
  const storeMarkerIconUrl = 'https://cdn.shopify.com/s/files/1/0783/9485/1640/files/favicon.png?v=1779961290';
  const googleMapsApiKey = 'AIzaSyAswv_Xv1lPQciRSKoK5aJl7iGsSVNq-8U';
  const googleMapStyles = [
    { elementType: 'geometry', stylers: [{ color: '#f5f5f5' }] },
    { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
    { elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
    { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f5f5' }] },
    {
      featureType: 'administrative.land_parcel',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#bdbdbd' }]
    },
    {
      featureType: 'poi',
      elementType: 'geometry',
      stylers: [{ color: '#eeeeee' }]
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#757575' }]
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [{ color: '#e5e5e5' }]
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#9e9e9e' }]
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [{ color: '#ffffff' }]
    },
    {
      featureType: 'road.arterial',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#757575' }]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [{ color: '#dadada' }]
    },
    {
      featureType: 'road.highway',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#616161' }]
    },
    {
      featureType: 'road.local',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#9e9e9e' }]
    },
    {
      featureType: 'transit.line',
      elementType: 'geometry',
      stylers: [{ color: '#e5e5e5' }]
    },
    {
      featureType: 'transit.station',
      elementType: 'geometry',
      stylers: [{ color: '#eeeeee' }]
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{ color: '#c9c9c9' }]
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#9e9e9e' }]
    }
  ];
  const stringCollator = typeof Intl !== 'undefined' ? new Intl.Collator(undefined, { sensitivity: 'base' }) : null;
  const mapViewportMediaQuery = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia('(max-width: 0px)') : null;
  const handleMapViewportChange = event => {
    if (!event.matches && storesData.length) {
      plotStoresOnMap(storesData);
    } else if (event.matches && googleInfoWindow) {
      googleInfoWindow.close();
    }
  };

  if (mapViewportMediaQuery) {
    if (mapViewportMediaQuery.addEventListener) {
      mapViewportMediaQuery.addEventListener('change', handleMapViewportChange);
    } else if (mapViewportMediaQuery.addListener) {
      mapViewportMediaQuery.addListener(handleMapViewportChange);
    }
  }

  window.closeDealerInfoWindow = function() {
    if (googleInfoWindow) {
      googleInfoWindow.close();
    }
  };

  document.addEventListener('DOMContentLoaded', function() {
    loadStoreData();
    setupEventListeners();

  });

  function setupEventListeners() {
    // Search
    const searchInput = document.getElementById('store-search');
    if (searchInput) {
      searchInput.addEventListener('input', handleSearchInput);
    }

    // State filter
    const stateFilter = document.getElementById('state-filter');
    if (stateFilter) {
      stateFilter.addEventListener('change', function() {
        filterStores();
      });
    }

    // Country filter
    const countryFilter = document.getElementById('country-filter');
    if (countryFilter) {
    countryFilter.addEventListener('change', function () {
        toggleStateFilter();
        populateStateFilter();
        filterStores();
    });
    }


    const sortSelect = document.getElementById('store-sort');
    if (sortSelect) {
      sortSelect.value = currentSortOption;
      sortSelect.addEventListener('change', handleSortChange);
    }
  }


  function loadStoreData() {
    console.log('Loading stores from Metaobjects:', easySearchData);

    if (!Array.isArray(easySearchData) || easySearchData.length === 0) {
      console.error('No store data found in Metaobjects');
      showError();
      hideLoading();
      return;
    }

    storesData = easySearchData
      .map(normaliseStoreRecord)
      .filter(store => store.name);

    console.log('Stores loaded:', storesData);

    if (storesData.length === 0) {
      console.error('No valid stores found');
      showError();
      hideLoading();
      return;
    }

    displayStores(storesData);

    // Keep your original map design
    plotStoresOnMap(storesData);

    // Keep auto country selection
    autoSelectUserCountry();

    hideLoading();
  }


  function autoSelectUserCountry() {
    fetch("https://ipapi.co/json/")
      .then(response => response.json())
      .then(data => {
        const userCountry = data.country_name; // United States, Australia etc.
console.log(userCountry)
        const countryFilter = document.getElementById("country-filter");

        if (!countryFilter || !userCountry) return;

        for (let option of countryFilter.options) {
          const optionCountryName = option.getAttribute("country-name");

          if (
            optionCountryName &&
            optionCountryName.toLowerCase().trim() === userCountry.toLowerCase().trim()
          ) {
            // select country
            countryFilter.value = option.value;

            // update state and stores
            populateStateFilter();
            toggleStateFilter();
            applyFiltersAndRender();

            console.log("Auto selected:", option.value, optionCountryName);
            break;
          }
        }
      })
      .catch(error => {
        console.log("Country detection failed:", error);
      });
  }

 function normaliseStoreRecord(entry) {

  const name = (entry.Name || entry.name || '').trim();

  const address = (entry.Address || entry.address || '').trim();

  const phone = (
    entry["Phone Number"] ||
    entry.phone_number ||
    entry.phone ||
    ''
  ).trim();

  const email = (
    entry["E-mail"] ||
    entry.e_mail ||
    ''
  ).trim();

  const state = (
    entry.State ||
    entry.state ||
    ''
  ).trim();

  const country = (
    entry.Country ||
    entry.country ||
    ''
  ).trim();

  const countryName = (
    entry["country name"] ||
    entry.country_name ||
    entry.countryName ||
    ''
  ).trim();

  const zipCode = String(
    entry["Zip Code"] ||
    entry.zip_code ||
    entry.zipCode ||
    ''
  ).trim();

  const website = (
    entry.Website ||
    entry.website ||
    entry.URL ||
    entry.url ||
    ''
  ).trim();

  // ✅ IMPORTANT: services fix
  const services = entry.services || entry.Services || [];

  const latitude = parseFloat(entry.Latitude || entry.latitude);
  const longitude = parseFloat(entry.Longitude || entry.longitude);

  return {
    id: `${name}-${zipCode}`.toLowerCase(),
    name,

    address: address
      .replace(/\n/g, ', ')
      .replace(/\s{2,}/g, ' ')
      .replace(/,\s*,/g, ', ')
      .trim(),

    phone,
    email,
    state,
    country,
    countryName,
    zipCode,
    website,

    // ✅ FIXED
    services: Array.isArray(services) ? services : [],

    latitude: Number.isFinite(latitude) ? latitude : null,
    longitude: Number.isFinite(longitude) ? longitude : null
  };
}

  function loadGoogleMapsScript() {
    if (typeof window.google === 'object' && window.google.maps) {
      return Promise.resolve(window.google);
    }

    if (googleMapsLoader) {
      return googleMapsLoader;
    }

    if (!googleMapsApiKey) {
      return Promise.reject(new Error('Google Maps API key not configured.'));
    }

    googleMapsLoader = new Promise((resolve, reject) => {
      window.initDealerMap = () => resolve(window.google);
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(googleMapsApiKey)}&callback=initDealerMap`;
      script.async = true;
      script.defer = true;
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return googleMapsLoader;
  }

  function ensureStoreMap() {
    return loadGoogleMapsScript()
      .then(() => {
        if (googleMap) {
          return googleMap;
        }

        const canvas = document.getElementById(storeMapCanvasId);
        if (!canvas) {
          throw new Error('Map canvas not found.');
        }

        googleMap = new google.maps.Map(canvas, {
          center: { lat: 37.8, lng: -96 },
          zoom: 4,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: true,
          styles: googleMapStyles
        });

        googleInfoWindow = new google.maps.InfoWindow();
        return googleMap;
      })
      .catch(error => {
        console.error('Google Maps failed to initialise:', error);
        throw error;
      });
  }

  function plotStoresOnMap(stores) {
    const wrapper = document.getElementById(storeMapWrapperId);
    if (!wrapper) return;
    if (isMapViewportDisabled()) {
      wrapper.classList.remove('is-visible');
      return;
    }

    ensureStoreMap()
      .then(() => {
        clearGoogleMarkers();

        const bounds = new google.maps.LatLngBounds();
        let plottedCount = 0;

        stores.forEach(store => {
          if (isValidCoordinate(store.latitude) && isValidCoordinate(store.longitude)) {
            const position = { lat: store.latitude, lng: store.longitude };
            
            const marker = new google.maps.Marker({
              position,
              map: googleMap,
              title: store.name || '',
              icon: {
                url: storeMarkerIconUrl,
                scaledSize: new google.maps.Size(32, 32),
                anchor: new google.maps.Point(16, 32)
              }
            });

            marker.addListener('click', () => {
              googleInfoWindow.setContent(buildMarkerPopup(store));
              googleInfoWindow.open(googleMap, marker);
            });

            googleMarkers.push({
              marker,
              store,
              storeId: store.id ? store.id.toString() : undefined
            });
            bounds.extend(position);
            plottedCount += 1;
          }
        });

        if (plottedCount > 0) {
          wrapper.classList.add('is-visible');
          if (plottedCount === 1) {
              googleMap.setCenter(bounds.getCenter());
              googleMap.setZoom(16);
            } else if (!bounds.isEmpty()) {
              googleMap.fitBounds(bounds, { padding: 40 });
            }
          }
         else {
          wrapper.classList.remove('is-visible');
        }
      })
      .catch(() => {
        wrapper.classList.remove('is-visible');
      });
  }

  function clearGoogleMarkers() {
    googleMarkers.forEach(entry => entry.marker.setMap(null));
    googleMarkers = [];
  }

  function focusStoreOnMap(storeId) {
    if (!storeId || isMapViewportDisabled()) return;
    const targetId = storeId.toString();

    ensureStoreMap()
      .then(() => {
        const target = googleMarkers.find(entry => entry.storeId === targetId);
        if (!target) {
          return;
        }

        const position = target.marker.getPosition();
        if (position) {
          googleMap.panTo(position);
          if (googleMap.getZoom() < 6) {
            googleMap.setZoom(6);
          }
        }

        googleInfoWindow.setContent(buildMarkerPopup(target.store));
        googleInfoWindow.open(googleMap, target.marker);
      })
      .catch(console.error);
  }

  function buildMarkerPopup(store) {
    const cleanPhone = (store.phone || '').replace(/[^\d]/g, '');
    const directionsUrl = store.address
      ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(store.address)}`
      : '';

    return `
      <div class=\"store-map-popup\">
        <div class=\"store-map-popup__header\">
          <button type=\"button\" class=\"store-map-popup__close\" onclick=\"window.closeDealerInfoWindow?.()\" aria-label=\"Close popup\">&times;</button>
          <h4 class=\"store-map-popup__title\">${escapeHtml(store.name || 'Store')}</h4>
          ${store.state ? `<span class=\"store-map-popup__state\">${escapeHtml(store.state)}</span>` : ''}
        </div>
        <div class=\"store-map-popup__body\">
          ${store.address ? `
            <div class=\"store-map-popup__info-row\">
              <svg class=\"store-map-popup__icon\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\">
                <path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z\"/>
                <path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M15 11a3 3 0 11-6 0 3 3 0 016 0z\"/>
              </svg>
              <span class=\"store-map-popup__text\">${escapeHtml(store.address)}</span>
            </div>` : ''}
          ${store.phone ? `
            <div class=\"store-map-popup__info-row\">
              <svg class=\"store-map-popup__icon\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\">
                <path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z\"/>
              </svg>
              <span class=\"store-map-popup__text\"><a href=\"tel:${cleanPhone}\">${escapeHtml(store.phone)}</a></span>
            </div>` : ''}
          ${store.email ? `
            <div class=\"store-map-popup__info-row\">
              <svg class=\"store-map-popup__icon\" viewBox=\"0 0 16 11.982\">
                <path fill=\"#292d32\" d=\"M81.437,178.631H68.231a1.4,1.4,0,0,0-1.4,1.4v9.188a1.4,1.4,0,0,0,1.4,1.4H81.437a1.4,1.4,0,0,0,1.4-1.4v-9.188A1.4,1.4,0,0,0,81.437,178.631Zm-6.588,6.983-6.32-6.051H81.08Zm6.588,4.067H68.231a.466.466,0,0,1-.465-.466v-9.048l6.726,6.441a.462.462,0,0,0,.551.076.467.467,0,0,0,.2-.111l6.657-6.464v9.106A.466.466,0,0,1,81.437,189.681Z\" transform=\"translate(-66.834 -178.631)\"/>
              </svg>
              <span class=\"store-map-popup__text\"><a href=\"mailto:${store.email}\">${escapeHtml(store.email)}</a></span>
            </div>` : ''}
          ${store.website ? `
            <div class=\"store-map-popup__info-row\">
              <svg class=\"store-map-popup__icon\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\">
                <path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9\"/>
              </svg>
              <span class=\"store-map-popup__text\"><a href=\"${escapeHtml(store.website)}\" target=\"_blank\" rel=\"noopener\">Visit Website</a></span>
            </div>` : ''}
        </div>
        ${(directionsUrl || store.phone) ? `
          <div class=\"store-map-popup__actions\">
            ${directionsUrl ? `<a class=\"store-map-popup__btn store-map-popup__btn--secondary\" href=\"${directionsUrl}\" target=\"_blank\" rel=\"noopener\">Directions</a>` : ''}
            ${store.phone ? `<a class=\"store-map-popup__btn\" href=\"tel:${cleanPhone}\">Call Now</a>` : ''}
          </div>` : ''}
      </div>
    `;
  }

  function isValidCoordinate(value) {
    return typeof value === 'number' && !Number.isNaN(value);
  }

  function isMapViewportDisabled() {
    return mapViewportMediaQuery ? mapViewportMediaQuery.matches : false;
  }

  function collectServices(stores) {
    const servicesSet = new Set();

    stores.forEach(store => {
      const services = store.services || store.Services || [];

      if (Array.isArray(services)) {
        services.forEach(s => servicesSet.add(s));
      } else if (typeof services === 'string') {
        services.split(',').forEach(s => servicesSet.add(s.trim()));
      }
    });

    allServices = [...servicesSet].filter(Boolean).sort();
  }

  function renderServicesFilter() {
    const wrapper = document.getElementById('services-filter-wrapper');
    const list = document.getElementById('services-checkbox-list');

    if (!wrapper || !list) return;

    if (allServices.length === 0) {
      wrapper.style.display = 'none';
      return;
    }

    wrapper.style.display = 'block';
    list.innerHTML = '';

    allServices.forEach(service => {
      const id = `service-${service.replace(/\s+/g, '-').toLowerCase()}`;

      const label = document.createElement('label');
      label.className = 'service-checkbox';

      label.innerHTML = `
        <input type="checkbox" value="${service}" id="${id}">
        <span>${service}</span>
      `;

      label.querySelector('input').addEventListener('change', handleServiceChange);

      list.appendChild(label);
    });
  }
  
  function handleServiceChange(e) {
    const value = e.target.value;

    if (e.target.checked) {
      selectedServices.push(value);
    } else {
      selectedServices = selectedServices.filter(s => s !== value);
    }

    applyFiltersAndRender();
  }

  function displayStores(stores) {
    allCountries = [...new Set(
        stores.map(store => store.country).filter(Boolean)
    )].sort();

    collectServices(stores); // ✅ ADD THIS
    populateCountryFilter();
    populateStateFilter();
    toggleStateFilter();
    renderServicesFilter(); // ✅ ADD THIS

    applyFiltersAndRender();
  }

  

  function populateCountryFilter() {
    const countryFilter = document.getElementById('country-filter');

    if (!countryFilter) return;

    countryFilter.innerHTML = '<option value="">All Countries</option>';

    const uniqueCountries = [];

    storesData.forEach(store => {
      // Skip empty country
      if (!store.country || !store.countryName) return;

      const exists = uniqueCountries.some(item => item.country === store.country);

      if (!exists) {
        uniqueCountries.push({
          country: store.country.trim(),
          countryName: store.countryName.trim()
        });
      }
    });

    // USA always on top
    uniqueCountries.sort((a, b) => {
        if (a.country === "USA") return -1;
        if (b.country === "USA") return 1;
        return a.country.localeCompare(b.country);
    });

    uniqueCountries.forEach(item => {
        const option = document.createElement('option');

        option.value = item.country;
        option.textContent = item.country;
        option.setAttribute('country-name', item.countryName);

        countryFilter.appendChild(option);
    });

  }

  function populateStateFilter() {
    const stateFilter = document.getElementById('state-filter');
    const countryFilter = document.getElementById('country-filter');

    if (!stateFilter) return;

    const selectedCountry =
        countryFilter ? countryFilter.value : '';

    let states = storesData
        .filter(store =>
        !selectedCountry ||
        store.country === selectedCountry
        )
        .map(store => store.state)
        .filter(Boolean);

    states = [...new Set(states)].sort();

    stateFilter.innerHTML =
        '<option value="">All States</option>';

    states.forEach(state => {
        const option = document.createElement('option');
        option.value = state;
        option.textContent = state;
        stateFilter.appendChild(option);
    });
  }

  function toggleStateFilter() {
    const countryFilter = document.getElementById('country-filter');
    const stateFilter = document.getElementById('state-filter');

    if (!countryFilter || !stateFilter) return;

    selectedServices = []; // reset services

    const checkboxes = document.querySelectorAll('#services-checkbox-list input');
    checkboxes.forEach(cb => cb.checked = false);

    if (countryFilter.value !== '') {
      stateFilter.style.display = 'block';
    } else {
      stateFilter.value = '';
      stateFilter.style.display = 'none';
    }
  }

  function displayStoresInView(stores) {
    const storeGrid = document.getElementById('store-grid');
    if (!storeGrid) return;
    storeGrid.innerHTML = '';
    
    stores.forEach((store, index) => {
      if (store.name) {
        const storeCard = createStoreCard(store, index);
        storeGrid.appendChild(storeCard);
      }
    });
  }

  function getFilteredStores() {
    const searchInput = document.getElementById('store-search');
    const stateFilter = document.getElementById('state-filter');
    const countryFilter = document.getElementById('country-filter');

    const searchTerm = searchInput?.value.toLowerCase().trim() || '';
    const selectedCountry = countryFilter?.value || '';
    const selectedState = stateFilter?.value || '';

    return storesData.filter(store => {
      const matchesCountry = !selectedCountry || store.country === selectedCountry;
      const matchesState = !selectedState || store.state === selectedState;

      // ✅ SERVICE FILTER
      let storeServices = store.services || store.Services || [];

      if (typeof storeServices === 'string') {
        storeServices = storeServices.split(',').map(s => s.trim());
      }

      const matchesServices =
        selectedServices.length === 0 ||
        selectedServices.every(s => storeServices.includes(s));

      const searchable =
        `${store.name || ''} ${store.address || ''} ${store.state || ''} ${store.country || ''} ${store.zipCode || ''}`
          .toLowerCase();

      const matchesSearch = !searchTerm || searchable.includes(searchTerm);

      return matchesCountry && matchesState && matchesSearch && matchesServices;
    });
  }

  function sortStores(stores) {
    const sorted = [...stores];
    if (currentSortOption === 'nearest') {
      sorted.sort((a, b) => getDistanceFromUser(a) - getDistanceFromUser(b));
      return sorted;
    }

    const [key, order] = currentSortOption.split('-');
    const direction = order === 'desc' ? -1 : 1;

    if (key === 'state') {
      sorted.sort((a, b) => {
        const primary = compareStrings(a.state, b.state);
        if (primary !== 0) return primary * direction;
        return compareStrings(a.name, b.name);
      });
    } else {
      sorted.sort((a, b) => {
        const primary = compareStrings(a.name, b.name);
        if (primary !== 0) return primary * direction;
        return compareStrings(a.state, b.state);
      });
    }

    return sorted;
  }

  function compareStrings(a, b) {
    if (stringCollator) {
      return stringCollator.compare(a || '', b || '');
    }
    return (a || '').localeCompare(b || '');
  }

  function toRadians(value) {
    return (value * Math.PI) / 180;
  }

  function getDistanceFromUser(store) {
    if (!userLocation || !isValidCoordinate(store.latitude) || !isValidCoordinate(store.longitude)) {
      return Number.POSITIVE_INFINITY;
    }

    const earthRadiusKm = 6371;
    const dLat = toRadians(store.latitude - userLocation.lat);
    const dLon = toRadians(store.longitude - userLocation.lng);
    const lat1 = toRadians(userLocation.lat);
    const lat2 = toRadians(store.latitude);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return earthRadiusKm * c;
  }

  function requestUserLocation() {
    if (userLocation) {
      return Promise.resolve(userLocation);
    }

    if (!navigator.geolocation) {
      return Promise.reject(new Error('Geolocation is not supported in this browser.'));
    }

    if (!userLocationPromise) {
      userLocationPromise = new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          position => {
            userLocation = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };
            userLocationPromise = null;
            resolve(userLocation);
          },
          error => {
            userLocationPromise = null;
            reject(error);
          },
          { enableHighAccuracy: false, maximumAge: 300000, timeout: 10000 }
        );
      });
    }

    return userLocationPromise;
  }

  function applyFiltersAndRender() {
    if (!Array.isArray(storesData) || storesData.length === 0) {
      return;
    }

    const filteredStores = getFilteredStores();
    const sortedStores = sortStores(filteredStores);

    displayStoresInView(sortedStores);
    plotStoresOnMap(sortedStores);

    const noResults = document.getElementById('no-results');
    const storeContent = document.querySelector('.store-content');
    
    if (sortedStores.length === 0) {
      if (noResults) noResults.style.display = 'block';
    } else {
      if (noResults) noResults.style.display = 'none';
    }
  }

  function handleSortChange(event) {
    const previousValue = currentSortOption;
    const selectedValue = event.target.value;

    if (selectedValue === 'nearest') {
      requestUserLocation()
        .then(() => {
          currentSortOption = selectedValue;
          applyFiltersAndRender();
        })
        .catch(error => {
          console.error('Unable to retrieve user location:', error);
          event.target.value = previousValue;
          if (!userLocation) {
            alert('We could not access your location. Please allow location permissions to sort by distance.');
          }
        });
      return;
    }

    currentSortOption = selectedValue;
    applyFiltersAndRender();
  }

  function createStoreCard(store, index) {
    const card = document.createElement('div');
    card.className = 'store-card';
    card.setAttribute('data-store-index', index);
    card.setAttribute('data-store-info', 
      `${store.name || ''} ${store.address || ''} ${store.phone || ''} ${store.email || ''} ${store.state || ''} ${store.zipCode || ''} ${store.website || ''}`.toLowerCase()
    );
    card.setAttribute('data-store-state', store.state || '');
    if (store.id !== undefined && store.id !== null) {
      card.setAttribute('data-store-id', store.id);
    }
    card.setAttribute('tabindex', '0');
    
    const cleanPhone = (store.phone || '').replace(/[^\d]/g, '');
    
    // Fix zip code duplication - check if address already contains zip code
    let displayAddress = (store.address || '').replace(/\n/g, ', ');
    if (store.zipCode && !displayAddress.includes(store.zipCode)) {
      displayAddress += ` ${store.zipCode}`;
    }
    
    // Fallback for empty address
    if (!displayAddress.trim()) {
      displayAddress = store.state ? `${store.state} ${store.zipCode || ''}`.trim() : 'Address not available';
    }
    
    const addressForDirections = `${store.address || ''} ${store.state || ''} ${store.zipCode || ''}`.replace(/\n/g, ' ').trim();

    console.log(store)
    
    card.innerHTML = `
      ${store.state ? `<span class="store-card-watermark">${escapeHtml(store.state)}</span>` : ''}
      <h3 class="store-name">${escapeHtml(store.name || 'Store Name Not Available')}</h3>

      ${store.services && store.services.length ? `
        <div class="store-services-badges">
          ${store.services.map(service => `
            <span class="service-badge">${escapeHtml(service)}</span>
          `).join('')}
        </div>
      ` : ''}
      
      <div class="store-info">
        <div class="store-info-item">
          <svg class="store-info-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>
          <span>${escapeHtml(displayAddress)}</span>
        </div>
        
        ${store.phone ? `
        <div class="store-info-item">
          <svg class="store-info-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
          </svg>
          <a href="tel:${cleanPhone}" class="store-phone-link">
            ${escapeHtml(store.phone)}
          </a>
        </div>
        ` : ''}

        ${store.email ? `
        <div class="store-info-item email-item">
          <svg class="store-info-icon" viewBox="0 0 16 11.982">
            <path fill="#292d32" d="M81.437,178.631H68.231a1.4,1.4,0,0,0-1.4,1.4v9.188a1.4,1.4,0,0,0,1.4,1.4H81.437a1.4,1.4,0,0,0,1.4-1.4v-9.188A1.4,1.4,0,0,0,81.437,178.631Zm-6.588,6.983-6.32-6.051H81.08Zm6.588,4.067H68.231a.466.466,0,0,1-.465-.466v-9.048l6.726,6.441a.462.462,0,0,0,.551.076.467.467,0,0,0,.2-.111l6.657-6.464v9.106A.466.466,0,0,1,81.437,189.681Z" transform="translate(-66.834 -178.631)"/>
          </svg>
          <a href="mailto:${store.email}" class="store-phone-link">
            ${escapeHtml(store.email)}
          </a>
        </div>
        ` : ''}


        ${store.website ? `
        <div class="store-info-item">
          <svg class="store-info-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M2 12h20"></path>
            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
          </svg>
          <a href="${escapeHtml(store.website)}" class="store-phone-link" target="_blank" rel="noopener">
            ${escapeHtml(store.website)}
          </a>
        </div>
        ` : ''}
      </div>
      
      <div class="store-actions">
        ${addressForDirections ? `
        <button type="button" class="button button--secondary" onclick="getDirections('${escapeHtml(addressForDirections)}')">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>
          &nbsp;Directions
        </button>
        ` : ''}
        ${store.phone ? `
        <button type="button" class="button button--primary" onclick="contactStore('${cleanPhone}')">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
          </svg>
          &nbsp;Call Now
        </button>
        ` : ''}
      </div>
    `;
    
    card.addEventListener('click', event => {
      if (event.target.closest('button') || event.target.closest('a')) {
        return;
      }
      focusStoreOnMap(store.id);
    });

    card.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        focusStoreOnMap(store.id);
      }
    });
    
    return card;
  }

  function filterStores() {
    applyFiltersAndRender();
  }

  function handleSearchInput() {
    clearTimeout(searchDebounceTimer);
    searchDebounceTimer = setTimeout(() => {
      filterStores();
    }, 1000);
  }

  function hideLoading() {
    document.getElementById('loading-state').style.display = 'none';
  }

  function showError() {
    document.getElementById('error-state').style.display = 'block';
  }

  function getDirections(address) {
    const encodedAddress = encodeURIComponent(address);
    const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
    window.open(mapsUrl, '_blank');
  }

  function contactStore(phone) {
    window.location.href = `tel:${phone}`;
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }